<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <label class="filter-item">
                    <h4>Date Range</h4>
                    <app-date-picker
                        id="dateRange"
                        :value="_dateRange"
                        type="daterange"
                        size="small"
                        class="no-icon"
                        @input="dateChanged"/>
                </label>
            </panel>
            <panel size="col-19">
                <h2 slot="title">Cancellations Report</h2>
                <template slot="buttons">
                    <app-button
                        size="small"
                        icon="icon-download"
                        class="no-text"
                        @click="handleDownload">
                        <span class="visuallyhidden">Download Report</span>
                    </app-button>
                </template>

                <el-table
                    :data="report"
                    :default-sort="{ prop: sort_by }"
                    style="width: 100%"
                    empty-text="None"
                    @sort-change="sortChange"
                    @current-change="navigateToCourseDetail">
                    <el-table-column
                        prop="date"
                        label="Date"
                        width="125px"
                        sortable="custom">
                        <template slot-scope="scope">
                            {{ scope.row.date | moment("MM/DD/YYYY") }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="course.title"
                        label="Course" 
                        sortable="custom"/>
                    <el-table-column
                        prop="course.crn"
                        label="CRN" 
                        sortable="custom"/>
                    <el-table-column
                        prop="notes"
                        label="Notes"/>
                    <el-table-column 
                        prop="created_at" 
                        label="Created At" 
                        width="135px" 
                        sortable="custom">
                        <template slot-scope="scope">
                            {{ scope.row.created_at | moment("MM/DD/YYYY") }}
                        </template>
                    </el-table-column>
                </el-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import table from '@/mixins/table'
import download from '@/mixins/download'

export default {
    name: 'page-reports-cancellation',
    components: { },
    mixins: [table, download],
    props: {
        start_date: {
            type: String,
            default: moment()
                .subtract(1, 'month')
                .format('YYYY-MM-DD')
        },
        end_date: {
            type: String,
            default: moment().format('YYYY-MM-DD')
        },
        per_page: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            dateRange: null,
            showCoursePicker: false,
            showTeamPicker: false,
            showEventPicker: false,
            tableParamKeys: [
                'start_date',
                'end_date'
            ]
        }
    },
    computed: {
        ...mapState({
            teamsList: ({ params }) => params.teams,
            report: ({ reportList }) => reportList.items,
            total: ({ reportList }) => reportList.total,
            authToken: ({ me }) => me.token
        }),
        ...mapGetters(['role']),
        _dateRange() {
            return [
                moment(this.start_date).toDate(), 
                moment(this.end_date).toDate()
            ]
        }
    },
    mounted() {
        this.paramsChanged(this.getParameters())
    },
    methods: {
        ...mapActions(['getCancellationReport']),
        handleDownload() {
            let params = this.getParameters()
            this.postParameters('/api/v2/download/report/cancellation',
                params,
                this.authToken)
        },
        navigateToCourseDetail({ course }) {
            this.$router.push({
                name: 'courses.detail',
                params: { uuid: course.uuid }
            })
        },
        paramsChanged(params) {
            this.getCancellationReport(params)
        },
        dateChanged(dateRange) {
            if (dateRange) {
                var parameters = this.getParameters()
                parameters.start_date = moment(dateRange[0]).format('YYYY-MM-DD')
                parameters.end_date = moment(dateRange[1]).format('YYYY-MM-DD')
                this.setParameters(parameters)
            }
        },
    }
}
</script>

<style lang="stylus">
.filters
    .app-date-picker
        width: 100% !important

    .el-date-editor.no-icon
        padding: 3px 10px !important

        .app-input__icon
            display: none

        .el-range-input
            width: 45%
</style>
